import { render, staticRenderFns } from "./ClinicDots.vue?vue&type=template&id=3155803f"
import script from "./ClinicDots.vue?vue&type=script&lang=js"
export * from "./ClinicDots.vue?vue&type=script&lang=js"
import style0 from "./ClinicDots.vue?vue&type=style&index=0&id=3155803f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports